<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="添加单位"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="660px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="单位名称：" prop="unitName">
          <el-input size="mini" v-model.trim="form.unitName" placeholder="请输入单位名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="客服电话：" class="mr0">
          <el-input size="mini" v-number-only:11 v-model.trim="form.consumerHotLine" placeholder="请输入客服电话" clearable></el-input>
        </el-form-item>
        <AddreassSelect :warning="addressWarn" class="input-with-col2" @change="setPojectAddress"></AddreassSelect>

        <el-form-item label="联系人：">
          <el-input size="mini" v-model.trim="form.principal" placeholder="请输入联系人" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" class="mr0">
          <el-input size="mini" v-number-only:11 v-model.trim="form.principalPhone" placeholder="请输入联系电话" clearable></el-input>
        </el-form-item>
        <el-form-item label="客户等级:" prop="grade">
          <el-select size="mini" v-model="form.grade" filterable placeholder="请选择客户等级" clearable>
            <el-option v-for="item in gradeList" :key="item" :label="item"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
      >确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addUnit } from "@/api/UseUnits";
import AddreassSelect from "../../../components/AddreassSelect/AddreassSelect";
export default {
  data() {
    return {
      form: {
        consumerHotLine: "",
        address: "",
        cityCode: "",
        unitName: "",
        districtCode: "",
        principal: "",
        principalPhone: "",
        provinceCode: ""
      },
      addressWarn: false,
      rules: {
        unitName: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "blur",
          },
        ],
      },
      gradeList: [
        "A","B","C","D","E"
      ],
      loadBtn: false,
    };
  },
  components: {
    AddreassSelect,
  },
  created() {},
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          const res = await addUnit(this.form);
          if (res.code === 200) {
            this.$message.success("添加成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
    setPojectAddress(data) {
      this.form.address = data.addressData; // 项目地址 详细地址
      this.form.provinceCode = data.provinceCode; // 项目地址省级 code
      this.form.provinceName = data.provinceName; // 项目地址省级 name
      this.form.cityCode = data.cityCode; // 项目地址城市 code
      this.form.cityName = data.cityName; // 项目地址城市 name
      this.form.districtCode = data.townCode; // 项目地址区级 code
      this.form.districtName = data.townName; // 项目地址区级 name
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/useUnits/components/AddUnit.vue